import React, { useEffect, useState } from "react";
import snackImg2 from "./assets/suporters png/1.png";
import snackImg3 from "./assets/suporters png/2.png";
import snackImg4 from "./assets/suporters png/3.png";

function ProudlyBacked() {
  const images = [snackImg2, snackImg3, snackImg4];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // Start fade out

      // Wait for fade-out before changing image
      setTimeout(() => {
        setCurrentImageIndex((prev) => (prev + 1) % images.length);

        // Add slight buffer before fade in
        setTimeout(() => {
          setFade(true); // Start fade in
        }, 150); // Buffer to allow image load/render
      }, 500); // Duration of fade out
    }, 5000);

    return () => clearInterval(interval);
  }, [images.length]);

  return (
    <div className="bg-white py-6 px-4 sm:px-6 md:px-10">
      <div className="text-center">
        <h2 className="font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl">
          Proudly Backed by Respected Administrative Partners
        </h2>
      </div>

      <div className="flex justify-center mt-10">
        <div className="w-full max-w-4xl px-4">
          <div className="rounded-lg hover:shadow-md transition-all duration-300">
            <div className="relative w-full h-[180px] sm:h-[220px] md:h-[250px] lg:h-[280px] flex items-center justify-center overflow-hidden">
              <img
                key={currentImageIndex} // forces re-render on image change
                src={images[currentImageIndex]}
                alt="Proudly Backed"
                className={`w-full h-full object-contain transition-opacity duration-700 ease-in-out ${
                  fade ? "opacity-100" : "opacity-0"
                }`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProudlyBacked;
  